import Pe from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import a from "../../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import f from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import Le from "../../../rc-util/es/hooks/useEvent.mjs";
import "../../../rc-util/es/hooks/useLayoutEffect.mjs";
import X from "../../../rc-util/es/hooks/useState.mjs";
import "../../../rc-util/es/ref.mjs";
import "../../../rc-util/es/warning.mjs";
import Re from "../../../rc-util/es/hooks/useSyncState.mjs";
import * as Y from "react";
import { useRef as x, useEffect as N } from "react";
import { STATUS_NONE as m, STATUS_APPEAR as A, STATUS_ENTER as T, STATUS_LEAVE as P, STEP_PREPARE as v, STEP_ACTIVE as L, STEP_PREPARED as ye, STEP_START as R } from "../interface.mjs";
import ge from "./useDomMotionEvents.mjs";
import De from "./useIsomorphicLayoutEffect.mjs";
import Me, { SkipStep as he, DoStep as Ve, isActive as Ie } from "./useStepQueue.mjs";
function Be(Q, u, Z, e) {
  var H = e.motionEnter, y = H === void 0 ? !0 : H, j = e.motionAppear, g = j === void 0 ? !0 : j, k = e.motionLeave, p = k === void 0 ? !0 : k, w = e.motionDeadline, b = e.motionLeaveImmediately, ee = e.onAppearPrepare, te = e.onEnterPrepare, ne = e.onLeavePrepare, re = e.onAppearStart, oe = e.onEnterStart, ae = e.onLeaveStart, ie = e.onAppearActive, ue = e.onEnterActive, se = e.onLeaveActive, D = e.onAppearEnd, M = e.onEnterEnd, h = e.onLeaveEnd, V = e.onVisibleChanged, me = X(), O = f(me, 2), i = O[0], ve = O[1], ce = Re(m), $ = f(ce, 2), q = $[0], l = $[1], fe = X(null), z = f(fe, 2), pe = z[0], B = z[1], r = q(), I = x(!1), _ = x(null);
  function d() {
    return Z();
  }
  var F = x(!1);
  function G() {
    l(m), B(null, !0);
  }
  var J = Le(function(n) {
    var t = q();
    if (t !== m) {
      var o = d();
      if (!(n && !n.deadline && n.target !== o)) {
        var S = F.current, E;
        t === A && S ? E = D == null ? void 0 : D(o, n) : t === T && S ? E = M == null ? void 0 : M(o, n) : t === P && S && (E = h == null ? void 0 : h(o, n)), S && E !== !1 && G();
      }
    }
  }), le = ge(J), de = f(le, 1), Se = de[0], K = function(t) {
    switch (t) {
      case A:
        return a(a(a({}, v, ee), R, re), L, ie);
      case T:
        return a(a(a({}, v, te), R, oe), L, ue);
      case P:
        return a(a(a({}, v, ne), R, ae), L, se);
      default:
        return {};
    }
  }, c = Y.useMemo(function() {
    return K(r);
  }, [r]), Ee = Me(r, !Q, function(n) {
    if (n === v) {
      var t = c[v];
      return t ? t(d()) : he;
    }
    if (s in c) {
      var o;
      B(((o = c[s]) === null || o === void 0 ? void 0 : o.call(c, d(), null)) || null);
    }
    return s === L && r !== m && (Se(d()), w > 0 && (clearTimeout(_.current), _.current = setTimeout(function() {
      J({
        deadline: !0
      });
    }, w))), s === ye && G(), Ve;
  }), W = f(Ee, 2), Ae = W[0], s = W[1], Te = Ie(s);
  F.current = Te, De(function() {
    ve(u);
    var n = I.current;
    I.current = !0;
    var t;
    !n && u && g && (t = A), n && u && y && (t = T), (n && !u && p || !n && b && !u && p) && (t = P);
    var o = K(t);
    t && (Q || o[v]) ? (l(t), Ae()) : l(m);
  }, [u]), N(function() {
    // Cancel appear
    (r === A && !g || // Cancel enter
    r === T && !y || // Cancel leave
    r === P && !p) && l(m);
  }, [g, y, p]), N(function() {
    return function() {
      I.current = !1, clearTimeout(_.current);
    };
  }, []);
  var C = Y.useRef(!1);
  N(function() {
    i && (C.current = !0), i !== void 0 && r === m && ((C.current || i) && (V == null || V(i)), C.current = !0);
  }, [i, r]);
  var U = pe;
  return c[v] && s === R && (U = Pe({
    transition: "none"
  }, U)), [r, s, U, i ?? u];
}
export {
  Be as default
};
//# sourceMappingURL=useStatus.mjs.map
